// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reaction-details-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2002; /* Higher than the attachment modal */
}

.reaction-details-modal-content {
  background-color: white;
  width: 325px;
  height: 350px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.reaction-details-modal-filters {
  display: flex;
  padding: 8px;
  border-bottom: 1px solid #e0e0e0;
  flex-wrap: wrap;
  gap: 8px;
}

.reaction-details-modal-filter-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 20px;
  background: white;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.reaction-details-modal-filter-btn:hover {
  background-color: #f0f0f0;
  border-color: #ccc;
}

.reaction-details-modal-filter-btn.active {
  background-color: #e0e0e0;
  border-color: #ccc;
  color: black;
}

.reaction-details-modal-list {
  padding: 8px 0;
  overflow: hidden;
}

.reaction-details-modal-user {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  transition: background-color 0.2s ease;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 16px;
  min-width: 0;
  box-sizing: border-box;
}

.reaction-details-modal-avatar {
  width: 36px;
  height: 36px;
  margin-right: 12px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
}

.reaction-details-modal-name {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  margin-right: 8px;
}

.reaction-details-modal-emoji {
  font-size: 18px;
}

.reaction-details-mxid {
  font-size: 12px;
  color: #888;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 180px;
}`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/ReactionDetailsModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".reaction-details-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2002; /* Higher than the attachment modal */\n}\n\n.reaction-details-modal-content {\n  background-color: white;\n  width: 325px;\n  height: 350px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.reaction-details-modal-filters {\n  display: flex;\n  padding: 8px;\n  border-bottom: 1px solid #e0e0e0;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.reaction-details-modal-filter-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  border-radius: 20px;\n  background: white;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.reaction-details-modal-filter-btn:hover {\n  background-color: #f0f0f0;\n  border-color: #ccc;\n}\n\n.reaction-details-modal-filter-btn.active {\n  background-color: #e0e0e0;\n  border-color: #ccc;\n  color: black;\n}\n\n.reaction-details-modal-list {\n  padding: 8px 0;\n  overflow: hidden;\n}\n\n.reaction-details-modal-user {\n  display: flex;\n  align-items: center;\n  padding: 8px 16px;\n  transition: background-color 0.2s ease;\n  font-family: Roboto, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.reaction-details-modal-avatar {\n  width: 36px;\n  height: 36px;\n  margin-right: 12px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.reaction-details-modal-name {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  margin-right: 8px;\n}\n\n.reaction-details-modal-emoji {\n  font-size: 18px;\n}\n\n.reaction-details-mxid {\n  font-size: 12px;\n  color: #888;\n  font-weight: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 180px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
